import React from 'react';
import FormPIIOTPVerificationPopup from './popup';

const FormPIIOTPVerificationModal = ({ isShow, modalOptions, modalData }) => {
  return (
    <FormPIIOTPVerificationPopup
      isOpen={isShow}
      isBackdropOverlap={true}
      zIndexBackdropOverlap={1055}
      modalOptions={modalOptions}
      modalData={modalData}
    />
  );
};

export default FormPIIOTPVerificationModal;
